import { IAppliedFilter, IToolTemplateBlock } from "@/app/models/auctor"
import { evaluateExpressionWithFiltersAndRowData } from "@/app/utils/expression-utils"

interface ITableBlockProps {
    block: IToolTemplateBlock
    expressionContext?: string
    appliedFilters: IAppliedFilter[]
    toolData: any
    queryParams?: Record<string, string> | null
}

interface ITableContent {
    head: string[]
    rows: any[][]
}

export default function TableBlock({
    block,
    toolData,
    appliedFilters,
    expressionContext,
    queryParams,
}: ITableBlockProps) {
    const { head, rows }: ITableContent = evaluateExpressionWithFiltersAndRowData(
        block.table_expression_value,
        toolData,
        appliedFilters,
        expressionContext,
        queryParams
    )

    // Mirrors the base (classic) WordPress `.wp-block-table table` recipe from
    // WPContentV2.scss: deep-green headers with rounded top corners over white cells,
    // the whole table reading as one rounded card (the last row rounds the bottom).
    const tableClassName = "border-separate border-spacing-0.5 w-full whitespace-nowrap"

    const headClassName = "text-center text-white px-2 py-3 font-semibold bg-deep-green rounded first:rounded-tl-2xl last:rounded-tr-2xl"

    const getCellClassName = (isLastRow: boolean) =>
        `text-center text-pale px-2 py-3 font-semibold bg-white border border-rm-gray-light rounded${
            isLastRow ? " first:rounded-bl-2xl last:rounded-br-2xl" : ""
        }`

    return (
        <div className={"overflow-hidden w-full px-4 relative"}>
            <div className={"overflow-x-auto w-full max-w-fit relative mx-auto custom-scrollbar"}>
                <table className={tableClassName}>
                    {head.length !== 0 && (
                        <thead>
                            <tr>
                                {head.map((colTitle, index) => {
                                    return (
                                        <th
                                            key={index}
                                            className={headClassName}
                                        >
                                            {colTitle}
                                        </th>
                                    )
                                })}
                            </tr>
                        </thead>
                    )}

                    <tbody className={""}>
                        {rows.map((row, rowIndex) => {
                            const cellClassName = getCellClassName(rowIndex === rows.length - 1)
                            return (
                                <tr key={rowIndex}>
                                    {row.map((content, index) => {
                                        return (
                                            <td
                                                key={index}
                                                className={cellClassName}
                                            >
                                                {content}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
